var exports = {
  "j0": "DirectMessageLayout.module__dmLayoutContainer___bTVpc0",
  "eN": "DirectMessageLayout.module__dmLayoutContainerFullscreen___bTVpc0",
  "Il": "DirectMessageLayout.module__dmListColumn___bTVpc0",
  "qy": "DirectMessageLayout.module__contentColumn___bTVpc0",
  "$f": "DirectMessageLayout.module__contentColumnFullscreen___bTVpc0",
  "YE": "DirectMessageLayout.module__contentInner___bTVpc0",
  "jk": "DirectMessageLayout.module__contentInnerFullscreen___bTVpc0",
};

module.exports = exports;
